<div *ngIf="customer">
  <div class="card">
    <div class="card-header card-title" *ngIf="customer.customerName" data-private>
      {{ customer.isIndividual?customer.customerName:(customer.customerName+' - '+customer.firstName+' '+customer.lastName)}}
    </div>

    <div class="card-body">

      <div class="row" *ngIf="customer.isBlackList">
        <span style="color:red;font-weight:bold">
          {{'message.warning.customer-is-blacklisted' | translate}}
        </span>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="(totalDebt != null && totalDebt > 0) || (currentAccountBalance != null && currentAccountBalance != 0)">
          <ng-container *ngIf="totalDebt != null && totalDebt > 0 && currentAccountBalance != null && currentAccountBalance != 0">
            <small class="info-label">{{'customer.totalDebtWithCurrentAccountBalance' | translate}}</small>
            <app-customer-total-debt-with-current-account-badge [balance]="(currentAccountBalance-totalDebt)" [totalDebt]="totalDebt" [currentAccountBalance]="currentAccountBalance"
              [showLabel]="false"></app-customer-total-debt-with-current-account-badge>

          </ng-container>

          <ng-container *ngIf="totalDebt != null && totalDebt > 0 && (currentAccountBalance == null || currentAccountBalance == 0)">
            <small class="info-label">{{'customer.totalDebt' | translate}}</small>
            <app-customer-total-debt-balance-badge [balance]="totalDebt" [showLabel]="false"></app-customer-total-debt-balance-badge>
          </ng-container>

          <ng-container *ngIf="currentAccountBalance != null && currentAccountBalance != 0 && (totalDebt == null || totalDebt == 0)">
            <small class="info-label">{{'customer.currentAccountBalance' | translate}}</small>
            <app-current-account-balance-badge [balance]="currentAccountBalance" [showLabel]="false"></app-current-account-balance-badge>
          </ng-container>
        </div>




        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="bonusBalance">
          <small class="info-label">{{'customer.bonusBalance' | translate}}</small>
          <app-bonus-balance-badge [balance]="bonusBalance" [showLabel]="false"></app-bonus-balance-badge>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="isCustomerScreen">
          <small class="info-label">{{'common.creationDate' | translate}}</small>
          <div class="info-content">{{ customer.creationDate | date: dateFormatEnum.DATE_FORMAT_DISPLAY }}</div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="customerTypeName">
          <small class="info-label">{{'customer.customerType' | translate}}</small>
          <div class="info-content"> {{ customerTypeName }}</div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="communityName">
          <small class="info-label">{{'customer.community' | translate}}</small>
          <div class="info-content"> {{ communityName }}</div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="customer.cardNumber">
          <small class="info-label">{{'customer.cardNumber' | translate}}</small>
          <div class="info-content" style="cursor: pointer; color: #007bff;" (click)="openLoyaltyCardUpdateModal()"> {{ customer.cardNumber | cardNumberFormat }}</div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="!isOrderScreen&&customer.discount>0">
          <small class="info-label">{{'common.discount' | translate}}</small>
          <div class="info-content">% {{ customer.discount }}</div>
        </div>

        <div data-private class="col-sm-12 col-md-12 col-lg-6" *ngIf="customer.mobilePhone">
          <div class="d-flex align-items-center justify-content-between">
            <small class="info-label">{{ 'communication.mobilePhone' | translate }}</small>
            <app-phone-call-option-widget [phoneNumber]="customer.mobilePhone" [customerId]="customer.id" [orderId]="orderId"></app-phone-call-option-widget>
          </div>
          <div class="info-content"> {{ customer.mobilePhone | phoneDisplayFormat:canDisplayPhoneUnmasked}}</div>
        </div>

        <div data-private class="col-sm-12 col-md-12 col-lg-6" *ngIf="customer.pstnPhone1">
          <div class="d-flex align-items-center justify-content-between">
            <small class="info-label">{{'communication.pstnPhone1' | translate}}</small>
            <app-phone-call-option-widget [phoneNumber]="customer.pstnPhone1" [customerId]="customer.id" [orderId]="orderId"></app-phone-call-option-widget>
          </div>
          <div class="info-content"> {{ customer.pstnPhone1 | phoneDisplayFormat:canDisplayPhoneUnmasked}}</div>
        </div>
        <div data-private class="col-sm-12 col-md-12 col-lg-6" *ngIf="customer.pstnPhone2">
          <div class="d-flex align-items-center justify-content-between">
            <small class="info-label">{{'communication.pstnPhone2' | translate}}</small>
            <app-phone-call-option-widget [phoneNumber]="customer.pstnPhone2" [customerId]="customer.id" [orderId]="orderId"></app-phone-call-option-widget>
          </div>
          <div class="info-content"> {{ customer.pstnPhone2 | phoneDisplayFormat:canDisplayPhoneUnmasked}}</div>
        </div>
        <div data-private class="col-sm-12 col-md-12 col-lg-6" *ngIf="customer.nationalPhone">
          <div class="d-flex align-items-center justify-content-between">
            <small class="info-label">{{'communication.nationalPhone' | translate}}</small>
            <app-phone-call-option-widget [phoneNumber]="customer.nationalPhone" [customerId]="customer.id" [orderId]="orderId"></app-phone-call-option-widget>
          </div>
          <div class="info-content"> {{ customer.nationalPhone | phoneDisplayFormat:canDisplayPhoneUnmasked}}</div>
        </div>
        <div data-private class="col-sm-12 col-md-12 col-lg-6" *ngIf="address?.siteName">
          <small class="info-label">{{'address.siteName' | translate}}</small>
          <div class="info-content"> {{ address.siteName }}</div>
        </div>

        <div data-private class="col-sm-12 col-md-12 col-lg-6" *ngIf="address?.buildingName">
          <small class="info-label">{{'address.buildingName' | translate}}</small>
          <div class="info-content"> {{ address.buildingName }}</div>
        </div>

        <div data-private class="col-sm-12 col-md-12 col-lg-6" *ngIf="address?.doorNum">
          <small class="info-label">{{'address.doorNum' | translate}}</small>
          <div class="info-content"> {{ address.doorNum }}</div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="address?.districtName">
          <small class="info-label">{{'address.district' | translate}}</small>
          <div class="info-content"> {{ address.districtName }}</div>
        </div>

        <div data-private class="col-sm-12 col-md-12" *ngIf="address?.description">
          <div>
            <small class="info-label">{{'address.description' | translate}}</small>
            <app-address-maps-widget [address]="address" class="pull-right"></app-address-maps-widget>
          </div>
          <div class="info-content"> {{ address.description }}</div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6" *ngIf="customerSourceName">
          <small class="info-label">{{'customer.customerSource' | translate}}</small>
          <div class="info-content"> {{customerSourceName}}</div>
        </div>


      </div>

      <div class="row">
        <div class="col-sm-12" *ngIf="!isOrderScreen && customer.notes">
          <small class="info-label">{{'common.notes' | translate}}</small>
          <div class="info-label-danger"> {{ customer.notes }}</div>
        </div>
        <div class="col-sm-12" *ngIf="customer.orderInstruction">
          <small class="info-label">{{'customer.orderInstruction' | translate}}</small>
          <div class="info-label-danger"> {{ customer.orderInstruction }} </div>

        </div>
      </div>
      <button class="btn btn-primary" type="button" (click)="goParentCustomer()" *ngIf="showParentCustomer && customer.parentCustomerId>0">
        {{'button.go-parent-customer' | translate}}
      </button>
    </div>
  </div>

  <div class="card" *ngIf="showBillingDetail&&customer.isBilling">
    <app-customer-billing-info-widget [customer]="customer"></app-customer-billing-info-widget>
  </div>
</div>